import { render, staticRenderFns } from "./UDEFeedback.vue?vue&type=template&id=0fcb9d06&scoped=true"
import script from "./UDEFeedback.vue?vue&type=script&lang=js"
export * from "./UDEFeedback.vue?vue&type=script&lang=js"
import style0 from "./UDEFeedback.vue?vue&type=style&index=0&id=0fcb9d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcb9d06",
  null
  
)

export default component.exports